"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFormattedSuggestionsV8 = void 0;
const types_1 = require("../../../types");
const findCategoryDisplayText_1 = require("../findCategoryDisplayText");
const sortFormattedSuggestions_1 = require("../sortFormattedSuggestions");
/**
 *
 * Builds and returns the sorted options for the typeahead dropdown
 * @param config Config
 * @param response TypeaheadResponse
 * @returns FormattedSuggestion[]
 */
function buildFormattedSuggestionsV8(config, response, term, maxTerms = 5) {
    var _a;
    const result = [];
    let curTerms = 0;
    for (const category in response) {
        if ((0, types_1.isValidTypeaheadCategoryV8)(category)) {
            curTerms = 0;
            (_a = response[category]) === null || _a === void 0 ? void 0 : _a.forEach((rawSuggestion) => {
                if (curTerms === maxTerms) {
                    return;
                }
                const suggestion = decorateV8Suggestion(rawSuggestion, term);
                result.push(buildSuggestionV8(category, suggestion, config));
                curTerms++;
            });
        }
    }
    return (0, sortFormattedSuggestions_1.sortFormattedSuggestions)(config, result);
}
exports.buildFormattedSuggestionsV8 = buildFormattedSuggestionsV8;
function buildQueryStringForSuggestionV8(config, category, suggestion) {
    const params = new URLSearchParams();
    if (suggestion.in_what) {
        params.append('in_what', suggestion.in_what);
    }
    if (suggestion.alias_term) {
        params.append('alias_term', suggestion.alias_term);
    }
    // KENG-33276 see note in api.ts around provider_name and name alias in search typeahead responses
    if (category === 'provider_name') {
        params.append('name', suggestion.value);
    }
    else {
        params.append(category, suggestion.value);
    }
    params.append('sort', config.params.sort_order.join(','));
    return `/search?${params.toString()}`;
}
function buildSuggestionV8(category, suggestion, config) {
    return {
        category: category,
        categoryDisplayText: (0, findCategoryDisplayText_1.findCategoryDisplayText)(config, category),
        highlight: suggestion.highlight,
        name: suggestion.name,
        queryString: buildQueryStringForSuggestionV8(config, category, suggestion),
        score: suggestion.score || 0
    };
}
function buildV8SuggestionHighlight(suggestion, term) {
    let { name } = suggestion;
    if (!name) {
        throw new Error('suggestion.name is required');
    }
    if (suggestion.in_what) {
        name += ` <em>in ${suggestion.in_what}</em>`;
    }
    return name.replace(new RegExp(term, 'gi'), '<em>$&</em>');
}
function decorateV8Suggestion(response, term) {
    const suggestion = {
        uuid: response.uuid,
        value: response.value,
        in_what: response.in_what,
        score: response.score,
        matched: response.matched
    };
    suggestion.alias_term = response.matched || response.name;
    suggestion.name = suggestion.alias_term || response.value;
    if (!suggestion.in_what && suggestion.matched) {
        suggestion.in_what = response.name;
    }
    suggestion.highlight = buildV8SuggestionHighlight(suggestion, term);
    return suggestion;
}
//# sourceMappingURL=buildFormattedSuggestionsV8.js.map